import * as React from 'react'
import { Icon } from '@atoms'

import classnames from 'classnames'
import { DEFAULT_AUTO_ANIMATE_SETTINGS } from '../../../../utils/constants'
import { useAutoAnimate } from '@formkit/auto-animate/react'
import { SelectOptionProps } from './types'

export const SelectOption: React.FC<SelectOptionProps> = (props) => {
    const [animationParent] = useAutoAnimate(DEFAULT_AUTO_ANIMATE_SETTINGS)
    const {
        selected,
        onChange,
        children,
        index,
        variant = 'primary',
        disabled,
    } = props

    const baseStyles = classnames(
        'w-full cursor-pointer outline-none flex py-3 px-4 gap-2 justify-between items-center text-label-small outline-none overflow-hidden whitespace-nowrap cursor-pointer'
    )

    const variants = {
        primary: {
            default: 'bg-white text-neutral-900 transition-all',
            focused: 'focus:outline-azure/25 focus:z-[1]',
            hover: 'hover:text-black hover:bg-blue-50',
            clicked: 'active:text-black active:bg-blue-100 active:outline-none',
            selected: '[&.active]:text-black [&.active]:bg-white',
        },
    }

    const variantObj = variants[variant]

    const optionWrapperClassname = classnames(
        baseStyles,
        variantObj.default,
        variantObj.hover,
        variantObj.selected,
        variantObj.clicked,
        variantObj.focused,
        props.optionWrapperClassname
    )

    const iconClassName = classnames(
        'relative h-4 w-4 text-blue-500',
        { 'opacity-0': !selected },

        // disabled
        'disabled:!text-disabled',
        'disabled:!border-disabled'
    )

    const optionLabelClassname = classnames(
        props.optionLabelClassname,
        'text-sm font-medium leading-6'
    )

    const wrapperClassname = classnames(optionWrapperClassname, {
        active: selected,
    })

    return (
        <button
            role="option"
            disabled={disabled}
            data-testid={`option-${index.toString()}`}
            className={wrapperClassname}
            ref={animationParent}
            onClick={onChange}
        >
            <div className={optionLabelClassname}>{children}</div>
            <div className={iconClassName}>
                <Icon name={'check'} size="small" className="u-icon" />
            </div>
        </button>
    )
}
